const timezoneActionTypes = {
  LOAD_TIMEZONES: 'LOAD_TIMEZONES',
  LOAD_TIMEZONES_SUCCESS: 'LOAD_TIMEZONES_SUCCESS',
  LOAD_TIMEZONES_ERROR: 'LOAD_TIMEZONES_ERROR',
};
export default timezoneActionTypes;
